// extracted by mini-css-extract-plugin
module.exports = {"ldsDualRing":"style_ldsDualRing__3OEdl","lds-dual-ring":"style_lds-dual-ring__1gbaC"};